import { createIcon } from '../createIcon.tsx';

export const CircleStackIcon = createIcon(
	'CircleStackIcon',
	<>
		<ellipse cx="12" cy="5" rx="9" ry="3" />
		<path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
		<path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
	</>,
);
